import { render, staticRenderFns } from "./NewGood.vue?vue&type=template&id=1d9b5376&"
import script from "./NewGood.vue?vue&type=script&lang=js&"
export * from "./NewGood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports